import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/core/service/app.service";
import { AuthService } from "src/app/core/service/auth.service";
import { EncryptDecryptParametersServiceService } from "src/app/core/service/encrypt-decrypt-parameters-service.service";
import { DoctorService } from "src/app/doctor/doctor.service";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { PrescriptionDetails } from "src/app/shared/models/prescriptionDetails";
import { PrescriptionPatientVM } from "src/app/shared/models/PrescriptionPatientVM";
import { PrescriptionService } from "../../prescription.service";
import { ReplaceModalComponent } from "../replace-modal/replace-modal.component";
import { SummaryModalComponent } from "../summary-modal/summary-modal.component";
import { Location } from "@angular/common";
import { UserAccount } from "src/app/shared/models/user-account";
import { NotificationService } from "src/app/shared/notification.service";
import { userRole } from "src/app/shared/userRole";
import { PatientService } from "src/app/doctor/patient/patient.service";
import { GcPdfViewer } from '@grapecity/gcpdfviewer';
declare var SignaturePad: any;
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ActivityType } from "src/app/shared/ActivityType";
import { Prescription } from "src/app/shared/models/prescription";
@Component({
  selector: "app-view-prescription",
  templateUrl: "./view-prescription.component.html",
  styleUrls: ["./view-prescription.component.sass"],
})
export class ViewPrescriptionComponent implements OnInit {
  @ViewChild("printPrescriptionConfirm") printPrescriptionConfirm: TemplateRef<any>;
  prescriptionDetails: any;
  drugList: PrescriptionDetails[];
  signaturePads: any;
  currentDate = new Date();
  replacedDrug: any[];
  prescriptionId: any;
  Patient: any;
  oldStatus: any;
  Comments: any;
  currentUser: UserAccount;
  pdfstring: any;
  prescription: Prescription;
  collectionLocation: any;
  statuschange: any;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private encryptDecryptParametersService: EncryptDecryptParametersServiceService,
    private doctorService: DoctorService,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    private pharmacistService: PharmcistService,
    private location: Location,
    private prescriptionService: PrescriptionService,
    private authService: AuthService,
    private patientService: PatientService,
    private notificationService: NotificationService,
  ) {
    this.prescriptionDetails = new PrescriptionPatientVM();
    this.replacedDrug = new Array<any>();
    this.Comments = "";
    this.currentUser = new UserAccount();
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  ngOnInit(): void {
    const finalURL =
      this.router.url.split("?")[0] +
      "?" +
      this.encryptDecryptParametersService.decrypt(this.router.url);
    var data = JSON.parse(
      this.encryptDecryptParametersService.getQueryParams("details", finalURL)
    );
    this.prescriptionId = data.Id;
    this.oldStatus = data.Status;

    // const finalURL =this.router.url.split("?")[0] +"?" +this.encryptDecryptParametersService.decrypt(this.router.url);
  var datas = JSON.parse(this.encryptDecryptParametersService.getQueryParams("details", finalURL));
  var newdata = datas;
    // var doctorAccountId = this.prescriptionDetails.Patient.PhysicianAccountId;
    // this.prescriptionId = this.prescriptionDetails.Prescription.Id;
    // this.drugList = this.prescriptionDetails.PrescriptionDetails;
    // this.drugList = res?.PrescriptionDetails;
    // this.prescriptionDetails.drugList = this.drugList;
    // if (this.prescriptionDetails != undefined) {
    //   this.getPatientDetailsById(this.prescriptionDetails.Patient.Id);
    // }
    this.getDrugListByPrescriptionId(this.prescriptionId);
  }

  replacementModal(row) {
    // TO DO API to  get patient details
    const dialogRef = this.dialog.open(ReplaceModalComponent, {
      data: {
        drug: row,
        action: "view",
      },
      width: "50%",
      maxWidth: "750px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result != null && result != undefined) {
          this.replacedDrug.push(result);
        }
      },
    });
  }

  summaryModal(row) {
    let drugs = [];
    if (this.replacedDrug.length != 0) {
      drugs = this.replacedDrug.filter(
        (x) => x.PrescriptionDetailsId == row.Id
      );
      var prescribeDrug = {
        Status: "Prescribed",
        Name: drugs[drugs.length - 1].OldDrugName,
        Description: drugs[drugs.length - 1].OldDrugDescription,
        Remark: "-",
        CreatedDate: this.prescriptionDetails.Prescription.CreatedDate,
        Refill: drugs[drugs.length - 1].OldDrugRefill,
      };
      drugs.push(prescribeDrug);
    }
    const dialogRef = this.dialog.open(SummaryModalComponent, {
      data: {
        drug: drugs,
        action: "view",
      },
      width: "100%",
      maxWidth: "750px",
      disableClose: true,
    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  getCurrentUserDetails(id) {
    const user = { Id: id };
    this.appService.getUser(user).subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          res.DateOfBirth =
            res.DateOfBirth !== null ? new Date(res.DateOfBirth) : null;
          this.prescriptionDetails.doctorUserAccount = res;
          // this.getDrugListByPrescriptionId(this.prescriptionId);
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getDrugListByPrescriptionId(id) {
    const prescriptionDetails = { prescriptionId: id };
    this.pharmacistService
      .GetDrugListByPrescriptionId(prescriptionDetails)
      .subscribe({
        next: (res) => {
          if (!res.HasErrors) {
            this.drugList = res.PrescriptionDetails;
            this.prescriptionDetails.drugList = this.drugList;
            this.prescriptionDetails.Doctor = res.Doctor;
            this.prescriptionDetails.Patient = res.Patient;
            this.prescriptionDetails.Prescription = res.Prescription;
            this.prescriptionDetails.doctorUserAccount = null;
            this.Comments = this.prescriptionDetails.Prescription.Comment;
            this.getCurrentUserDetails(
              this.prescriptionDetails.Patient.PhysicianAccountId
            );
            this.getReplaceItemListById(
              this.prescriptionDetails.Prescription.Id
            );
            this.spinner.hide();
            if(this.prescriptionDetails.Prescription.CollectionLocation!="" && this.prescriptionDetails.Prescription.CollectionLocation!=null)
            {
              this.collectionLocation = this.prescriptionDetails.Prescription.CollectionLocation
              this.collectionLocation = [this.collectionLocation.split(":")[1]];
            }
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  clearSignature(): void {
    this.signaturePads.clear();
  }
  back() {
    if (this.currentUser.UserRoleId != userRole.doctor) {
      this.router.navigate(["/pharmacist/prescription/list"]);
    } else {
      this.router.navigate(["/doctor/prescription/list"]);
    }
  }

  getPatientDetailsById(Id: any) {
    var patientDetails = {
      patientDetails: Id,
    };
    this.spinner.show();
    this.patientService.GetPatient(patientDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.Patient = resp;
          this.getCurrentUserDetails(this.Patient.PhysicianAccountId);
          this.spinner.hide();
        } else {
          this.authService.showNotification(
            "snackbar-danger",
            "something went wrong.",
            "top",
            "center"
          );
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getReplaceItemListById(id) {
    this.spinner.show();
    const prescriptionDetails = { prescriptionId: id };
    this.prescriptionService.GetReplaceItems(prescriptionDetails).subscribe({
      next: (res: any) => {
        if (!res.HasErrors) {
          this.replacedDrug = res.Rows;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  IsDrugExist(drugId) {
    return this.replacedDrug.find((x) => x.NewDrugId == drugId);
  }

  GetRemark(drugId) {
    return this.replacedDrug.find((x) => x.NewDrugId == drugId);
  }
  printPrescription()
  {
    const dialogRef = this.dialog.open(this.printPrescriptionConfirm, {
      data: {
        doctor: "nikhil demo",
        action: "delete",
      },
      width: "100%",
      height: "250px",
      maxWidth: "600px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        this.authService.showNotification(
          "snackbar-success",
          "Delete Record Successfully.",
          "bottom",
          "center"
        );
      }
    });
  }

  prescriptionStatusChange(row:any)
  {
    this.statuschange=row;
    this.closeDialog();
    this.spinner.show();
    
    
    //this.downloadPrescription(row)
    this.ChangePrescriptionStatus(row,true)
    this.spinner.hide();
  }
  prescriptionNotStatusChange(row:any)
  {
    this.statuschange=row;
    this.closeDialog();
    this.spinner.hide();
    //this.downloadPrescription(row)
    this.ChangePrescriptionStatus(row,'')
    
  }

  ChangePrescriptionStatus(prescriptionDetails, status:any) {
    if(status){ var chnagesstatus ="No Tracking"}
    // var changedStatus = {
    //   prescriptionId: prescriptionDetails.Prescription.Id,
    //   newStatus: chnagesstatus || "",
    //   isLock: prescriptionDetails.Prescription.IsLock,
    //   isLockBy: prescriptionDetails.Prescription.IsLockBy,
    //   isPrinted:prescriptionDetails.Prescription.IsPrinted
    // };

    var changedStatus = {
      "prescriptionDetails":{}
    };
    changedStatus.prescriptionDetails={
      "Id":prescriptionDetails.Prescription.Id,
      "Status":chnagesstatus || "",
      "IsLock":prescriptionDetails.Prescription.IsLock,
      "IsLockBy":prescriptionDetails.Prescription.IsLockBy,
      "IsPrinted":prescriptionDetails.Prescription.IsPrinted
    }

    
    this.spinner.show();
    this.downloadPrescription(this.statuschange)
    this.prescriptionService.ChangePrescriptionStatus(changedStatus).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          prescriptionDetails.Prescription = resp;
          // this.spinner.hide();
          this.notificationService.SendPrescription(
            prescriptionDetails.Prescription
          );
          const encryptedstring = this.encryptDecryptParametersService.encrypt(
            `details=${JSON.stringify({
              Id: prescriptionDetails.Prescription.Id,
              Status: chnagesstatus,
            })}`
          );
          this.router.navigateByUrl(
            // `/pharmacist/prescription/fill?${encryptedstring}`
            `/pharmacist/prescription/list`
          );
        } else {
          this.authService.showNotification(
            "snackbar-danger",
            "something went wrong.",
            "top",
            "center"
          );
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  createToken(row:any)
  {
    this.downloadAsPDF();
  }

  downloadAsPDF() {
    let DATA: any = document.getElementById('pdfTable');
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 4;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'in', 'a4');
      let position = 2.7;
      PDF.addImage(FILEURI, 'PNG', 2, position, fileWidth, fileHeight);
      PDF.save('Prescription_' + new Date() + '.pdf');
      PDF.autoPrint();
      PDF.output('dataurlnewwindow');
    });
  }

// Pricription PDF
  downloadPrescription(row: any) { 
    this.spinner.show();
    var prescriptionDetails = {
      prescriptionDetails: row.Prescription.Id,
    };
    this.prescriptionService
      .DownloadPrescription(prescriptionDetails)
      .subscribe({
        next: (resp: any) => {
          if (!resp.HasErrors) {
            this.closeDialog();
            this.pdfstring = resp.pdf;
            this.downloadFile(this.pdfstring, "application/pdf", "download");
            this.AddUserActivity(
              this.currentUser.FirstName + " " + this.currentUser.LastName,
              this.currentUser.Id,
              ActivityType.DownloadPrescription,
              "Download Prescription",
              "Prescription " +
                row.Prescription.PrescriptionNo +
                " is downloaded by " +
                this.currentUser.FirstName +
                " " +
                this.currentUser.LastName
            );
           // this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  downloadFile(data: string, fileType: any, type: string): void {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url  = window.URL.createObjectURL(blob);
    if (type === "print") {
      window.location.href = url;
    } else {
      const downloadPDF = document.createElement("a");
      downloadPDF.href = url;
      this.printPDF(downloadPDF.href)
      downloadPDF.download = "Prescription_" + new Date() + ".pdf";
      downloadPDF.click();
    }
  }

  AddUserActivity(
    username,
    userAccountId,
    activityType,
    activityName,
    description
  ) {
    var userActivity = {
      ActivityType: activityType,
      ActivityName: activityName,
      UserName: username,
      Description: description,
      UserAccountId: userAccountId,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
        }
      },
      error: () => {},
    });
  }

  printPDF(url)
  {
      let pdfFrame = document.body.appendChild(document.createElement('iframe'));
      pdfFrame.style.display = 'none';
      pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
      pdfFrame.src = url;
  }
}